export default {
	section_banner: {
		title: {
			one: 'Convenient API',
		},
		main_title: {
			one: 'Quickly',
			two: 'Integrates',
		},
		sub_title: 'Various Payments',
		cta_buttons: {
			one: 'Learn More',
			two: 'Download App',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
